import React, { Suspense } from "react";
import { AppLayout } from "./AppLayout";
import { Switch, Route } from "react-router";
import { Navbar } from "./Navbar/Navbar";
import { UserManagement } from "./UserManagement";
import { HomePage } from "./Home/Home";
import { Footer } from "./Footer";
import { FinancialReport } from "./EOD/FinancialReport/FinancialReport";
import { TerminalManagement } from "./TerminalManagement";
import { ItemReturnManagement } from "./ItemReturn/ItemReturnManagement";
import { BillManagement } from "./Bills/BillManagement";
import { TerminalUsersManagement } from "./TerminalUsers/TerminalUsersManagement";
import { RoleManagement } from "./RoleManagement/RoleManagement";
import { DepartmentManagement } from "./DepartmentManagement/DepartmentManagement";
import { CreditCustomerManagement } from "./CreditCustomers/CreditCustomerManagement";
import { EodMaster } from "./EOD/EodMaster";
import { PosConfigurationMaster } from "./Configurations/PosConfiguration/PosConfigurationMaster";
import { StoreConfigurationMaster } from "./Configurations/StoreConfiguration/StoreConfigurationMaster";
import { ServiceManagement } from "./ServiceManagement/ServiceManagement";
import { PosServiceNotification } from "./Notifications";
import { DivisionManagement } from "./DivisionManagement/DivisionManagement";
import { CompanyManagement } from "./CompanyDetails/CompanyManagement";
// import { ItemReturnVoucherManagement } from "./ItemReturnVoucher/ItemReturnVoucherMangement";
import { SuspendedBillManagement } from "./SuspendedBills/SuspendedBillManagement";
import { CashierReconciliationManagement } from "./CashierReconciliation/CashierReconciliationManagement";
import { StoreManagement } from "./StoreDetails/StoreManagement";
import { VoucherManagement } from "./VoucherManagement/VoucherManagement";
import { UserLogManagement } from "./UserLogManagement/UserLogManagement";
import { CurrencyManagement } from "./CurrencyManagement/CurrencyManagement";
import { ResyncConfTables } from "./ResyncConfigurationTables/ResyncConfTablesView/ResyncConfTables";
import { ResyncConfTablesManagement } from "./ResyncConfigurationTables/ResyncConfTablesManagement";
import { ProductSyncManagement } from "./ProductSync/ProductSyncManagement";

export const AppViews = () => (
  
  <AppLayout>
    <AppLayout.Header>
      <Navbar />
    </AppLayout.Header>
    <AppLayout.Body>
      <Suspense fallback={<h1>Loading...</h1>}>
        <Switch>
          <Route exact path="/" render={() => <HomePage />} />
          <Route path="/users" render={() => <UserManagement />} />
          <Route path="/terminals" render={() => <TerminalManagement />} />
          <Route path="/bills" render={() => <BillManagement />} />
          <Route
            path="/terminalusers"
            render={() => <TerminalUsersManagement />}
          />
          <Route path="/eod" component={EodMaster} />
          <Route path="/financial" component={FinancialReport} />
          <Route path="/itemreturn" render={() => <ItemReturnManagement />} />          
          <Route path="/roles" render={() => <RoleManagement />} />
          <Route path="/departments" component={DepartmentManagement} />
          <Route path="/creditcustomers" component={CreditCustomerManagement} />
          <Route path="/configuration/pos" component={PosConfigurationMaster} />
          <Route
            path="/configuration/store"
            component={StoreConfigurationMaster}
          />
          <Route path="/services" component={ServiceManagement} />
          <Route path="/posServices" component={PosServiceNotification} />
          <Route path="/divisions" component={DivisionManagement} />
          <Route path="/company" component={CompanyManagement} />
          <Route path="/store" component={StoreManagement} />
          {/* <Route path="/itemReturnVoucher" component={ItemReturnVoucherManagement } /> */}
          <Route path="/suspendedbills" component={SuspendedBillManagement} />
          <Route
            path="/cashier-reconciliation"
            component={CashierReconciliationManagement}
          />
          <Route path="/user-log" component={UserLogManagement} />
          <Route path="/vouchers" component={VoucherManagement} />
          <Route path="/currency" component={CurrencyManagement} />
          <Route path="/resync" component={ResyncConfTablesManagement} />
          <Route path="/product-sync" component={ProductSyncManagement} />
        </Switch>
      </Suspense>
    </AppLayout.Body>
    <AppLayout.Footer>
      <Footer />
    </AppLayout.Footer>
  </AppLayout>
  
);
